import { useCallback } from 'react';

import { useSpotlightStore } from '@repo/front-end-state';

/**
 * Triggers an in-app spotlight fly-to for the given BID without touching the
 * URL.
 *
 * Thin wrapper around `SpotlightStore.fireSpotlight` so consumers get a stable
 * callback identity (safe in `useEffect` / `useCallback` deps). The store
 * action handles atomic BID + fire-count update; useSpotlight reacts to the
 * count, so re-submitting the same BID still re-fires the flight.
 *
 * Empty / whitespace-only input is a no-op.
 */
export const useFlyToBid = () => {
  return useCallback((bid: string) => {
    useSpotlightStore.getState().fireSpotlight(bid);
  }, []);
};
